// extracted by mini-css-extract-plugin
export default {"header":"Home_header__2cgJD","content":"Home_content__ebp7f"};